// eslint-disable-next-line import/no-unresolved
const processInclude = require('base/util');
const outOfStock = require('./product/outOfStock');

$(document).ready(() => {
    processInclude(outOfStock);
});
